<script>
import options from './FilterPager.options'
export default options
</script>

<template>
    <article class="nti-filter-pager">

        <template v-if="displayPager">

            <template v-if="decrementPage">
                <button class="nti-filter-pager__button" @click="decrementPage.clickHandler" >
                   <div class="nti-svg__container-small">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path
                                d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                            />
                        </svg>
                    </div>
                </button>
            </template>

            <div class="nti-filter-pager__number-button__container">
                <template v-for="(page,index) in pagerRenderData" :key="index">

                    <template v-if="page.type === 'page'">
                        <button class="nti-filter-pager__number-button nti-filter-pager__button" :class="page.current ? 'nti-filter-pager--current' : ''" :ref="page.current ? 'activepage' : 'donotfocusme'" @click="page.clickHandler">{{page.displayNumber}}</button>
                    </template>

                    <template v-if="page.type === 'split'">
                        <span :key="index">...</span>
                    </template>
                    
                </template>
            </div>

            <template v-if="incrementPage">
                <button class="nti-filter-pager__next-button nti-filter-pager__button" @click="incrementPage.clickHandler" >
                    <div class="nti-svg__container-small">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </div>
                </button>
            </template>

        </template>

    </article>
</template>